<template>
  <section class="topo">
    <div class="ajustes">
      <a class="voltar" href="/inicio">
        <Svgs nome="setinha"></Svgs>
      </a>
      <button class="opcao" @click="toggleConteudo" :class="{ ativo: storeEditar.mostrarConteudo }">
        <Svgs nome="play" />
        <p>{{ storeCursos.cursos?.length }} Cursos</p>
      </button>
      <button class="opcao" @click="toggleAlunos" :class="{ ativo: storeEditar.mostrarAlunos }">
        <Svgs nome="usuarios" />
        <p>{{ storeAlunos.alunos?.length }} Alunos</p>
      </button>
      <button class="opcao" @click="toggleConfiguracoes" :class="{ ativo: storeEditar.mostrarConfiguracoes }">
        <Svgs nome="ferramentas" />
        <p>Configurações</p>
      </button>
    </div>
    <!-- Nome -->
    <div class="nome" ref="editar">
      <div class="info">
        <h3 @click="state.editarNome = !state.editarNome">{{ helperTexto.limitarCaracteres(storeAreas.area?.nome, 20) }}</h3>
        <span></span>
        <a v-if="storeAreas.area?.dominioPersonalizado" class="dominio" target="_blank" :href="`https://${storeAreas.area?.dominioPersonalizado}`">{{ storeAreas.area?.dominioPersonalizado }}</a>
        <a :href="`https://mber.live/${storeAreas.area?.hotlink}`" target="_blank" v-else>
          {{ 'mber.live/' + helperTexto.limitarCaracteres(storeAreas.area?.hotlink, 15) }}
        </a>
      </div>
      <div class="status" :class="storePerfil.usuario?.assinatura?.ativo ? 'on' : 'off'">
        <span></span>
        <h3>{{ storePerfil.usuario?.assinatura?.ativo ? 'Online' : 'Offline' }}</h3>
      </div>
      <div class="editar" :class="{ mostrar: state.editarNome }">
        <Campo tipo="text" placeholder="Nome da sua área" completar="false" label="Nome da Área" v-model="state.nome" />
        <div class="botoes">
          <BotaoSecundario nome="Salvar" cor="azul" tamanho="metade" @click="salvarNome()" :disabled="state.editandoNome" />
          <BotaoSecundario @click="state.editarNome = !state.editarNome" nome="Cancelar" cor="cinza" tamanho="metade" />
        </div>
      </div>
    </div>
    <!-- Opções -->
    <div class="opcoes">
      <button class="ver" @click="storeTema.toggleTema()">
        <Svgs :nome="storeTema.tema === 'escuro' ? 'sol' : 'lua'" />
      </button>
      <div class="subir" ref="subir">
        <button class="abrir" @click="state.subirAgora = !state.subirAgora">
          <Svgs nome="foguete" />
          <p>Ver área no ar</p>
        </button>
        <div class="subindo" :class="{ mostrar: state.subirAgora }">
          <div class="info free" v-if="storePerfil.usuario?.assinatura?.plano === 'free'">
            <Svgs nome="levelmember-icone" />
            <p>Faça sua assinatura para sua área ir ao ar</p>
            <BotaoSecundario nome="Assinar Agora" cor="verde" tamanho="inteiro" @click="router.push('/planos')" />
          </div>
          <div class="info" v-else>
            <a v-if="storeAreas.area?.dominioPersonalizado" class="link" target="_blank" :href="`https://${storeAreas.area?.dominioPersonalizado}`">
              <Svgs nome="link" />
              <p>{{ storeAreas.area?.dominioPersonalizado }}</p>
            </a>
            <a :href="`https://mber.live/${storeAreas.area?.hotlink}`" class="link" target="_blank">
              <Svgs nome="link" />
              <p>{{ 'mber.live/' + helperTexto.limitarCaracteres(storeAreas.area?.hotlink, 15) }}</p>
            </a>
            <div class="usuario">
              <div class="foto" :style="`background-image: url('${storePerfil.usuario?.imagemPerfil}')`"></div>
              <p>Área de {{ helperTexto.primeiroNome(storePerfil.usuario?.nome) }} já no ar</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { reactive, onMounted, onUnmounted, ref, watch, inject } from 'vue'
import { useStoreEditar, useStoreAreas, useStorePerfil, useStoreTema, useStoreAlunos, useStoreCursos } from '@stores'
import { helperTexto } from '@helpers'
import { useRouter } from 'vue-router'
import Campo from '@/components/global/elementos/Campo.vue'
import BotaoSecundario from '@/components/global/elementos/BotaoSecundario.vue'
import Svgs from '@svgs'

const state = reactive({
  nome: '',
  editarNome: false,
  subirAgora: false,
  editandoNome: false,
  subindoAgora: false
})

const emitter = inject('emitter')
const storeTema = useStoreTema()
const storeEditar = useStoreEditar()
const storeAreas = useStoreAreas()
const storePerfil = useStorePerfil()
const storeAlunos = useStoreAlunos()
const storeCursos = useStoreCursos()
const router = useRouter()
const editar = ref(null)
const subir = ref(null)

function fecharSeClicarFora(event) {
  if (editar.value && !editar.value.contains(event.target)) {
    state.editarNome = false
  }
  if (subir.value && !subir.value.contains(event.target)) {
    state.subirAgora = false
  }
}

function toggleAlunos() {
  const novoEstado = !storeEditar.mostrarAlunos
  storeEditar.mostrarAlunos = novoEstado
  storeEditar.mostrarConfiguracoes = false
  storeEditar.mostrarConteudo = false
}

function toggleConfiguracoes() {
  const novoEstado = !storeEditar.mostrarConfiguracoes
  storeEditar.mostrarConfiguracoes = novoEstado
  storeEditar.mostrarAlunos = false
  storeEditar.mostrarConteudo = false
}

function toggleConteudo() {
  const novoEstado = !storeEditar.mostrarConteudo
  storeEditar.mostrarConteudo = novoEstado
  storeEditar.mostrarAlunos = false
  storeEditar.mostrarConfiguracoes = false
}

async function salvarNome() {
  state.editandoNome = true

  const payload = {
    idArea: storeAreas.area?._id,
    nome: state.nome
  }

  const edicaoOk = await storeAreas.alterarDados(payload)
  if (edicaoOk !== true) return

  state.editandoNome = false
  state.editarNome = false
  emitter.emit('atualizarArea')
  emitter.emit('mostrarAlerta', { tipo: 'positivo', mensagem: 'Nome alterado com sucesso!' })
}

watch(
  () => storeAreas.area,
  (novoValor) => {
    if (novoValor) {
      state.nome = storeAreas.area?.nome
    }
  },
  { immediate: true }
)

onMounted(() => {
  storeTema.carregarTema()
  document.addEventListener('click', fecharSeClicarFora)
})

onUnmounted(() => {
  document.removeEventListener('click', fecharSeClicarFora)
})
</script>

<style scoped>
section.topo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: var(--cor-escuro-2);
  border-bottom: 2px solid var(--cor-escuro-3);
  z-index: 6;
}
.nome {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 33.33%;
}
.nome .info {
  display: flex;
  align-items: center;
}
.nome .info h3 {
  font-family: var(--medium);
  font-size: var(--f1);
  color: var(--cor-branco);
  cursor: pointer;
}
.nome .info span {
  height: 15px;
  width: 1px;
  background-color: var(--cor-escuro-4);
  margin: 0 10px;
}
.nome .info a {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  transition: all 0.3s;
}
.nome .info a:hover {
  color: var(--cor-branco);
}
.nome .editar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 250px;
  min-width: 250px;
  padding: 15px;
  position: absolute;
  top: 50px;
  background-color: var(--cor-escuro-1);
  border: 2px solid var(--cor-escuro-3);
  border-radius: 8px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translate(0, 20px);
  transition: all 0.3s;
}
.nome .editar.mostrar {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
  transform: translate(0, 0);
}
.nome .editar .campo {
  margin: 0 0 10px 0;
}
.nome .editar .botoes {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.nome .status {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px 6px;
  border-radius: 50px;
  background-color: var(--cor-escuro-4);
  margin: 0 0 0 10px;
  transition: all 0.3s;
}
.nome .status.on {
  background-color: #0dc78f2b;
}
.nome .status.off {
  background-color: #ff25582b;
}
.nome .status.on h3 {
  color: var(--cor-verde);
}
.nome .status.on span {
  background-color: var(--cor-verde);
}
.nome .status.off h3 {
  color: var(--cor-vermelho);
}
.nome .status.off span {
  background-color: var(--cor-vermelho);
}
.nome .status h3 {
  font-family: var(--medium);
  font-size: var(--f0);
  color: var(--cor-branco);
  transition: all 0.3s;
}
.nome .status span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--cor-branco);
  margin: 0 5px 0 0;
  transition: all 0.3s;
}
.ajustes {
  display: flex;
  align-items: center;
  padding: 0 0 0 15px;
  width: 33.33%;
}
.ajustes a.voltar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 8px;
  background-color: var(--cor-escuro-3);
  transition: all 0.3s;
}
.ajustes a.voltar:hover {
  background-color: var(--cor-escuro-4);
}
.ajustes a.voltar:hover svg {
  fill: var(--cor-branco);
}
.ajustes a.voltar svg {
  width: 15px;
  min-width: 15px;
  fill: var(--cor-escuro-6);
  transform: rotate(90deg);
  transition: all 0.3s;
}
.ajustes button.opcao {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  background-color: transparent;
  margin: 0 0 0 15px;
  transition: all 0.3s;
}
.ajustes button.opcao:hover svg {
  fill: var(--cor-branco);
}
.ajustes button.opcao:hover p {
  color: var(--cor-branco);
}
.ajustes button.opcao.ativo svg {
  fill: var(--cor-branco);
}
.ajustes button.opcao.ativo p {
  color: var(--cor-branco);
}
.ajustes button.opcao svg {
  width: 15px;
  min-width: 15px;
  fill: var(--cor-escuro-6);
  margin: 0 5px 0 0;
  transition: all 0.3s;
}
.ajustes button.opcao p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  transition: all 0.3s;
}
.opcoes {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 15px 0 0;
  width: 33.33%;
  position: relative;
}
.opcoes button.ver {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 8px;
  background-color: var(--cor-escuro-3);
  margin: 0 10px 0 0;
  transition: all 0.3s;
}
.opcoes button.ver.ativo {
  background-color: var(--cor-marca);
}
.opcoes button.ver.ativo:hover {
  background-color: var(--cor-marca);
}
.opcoes button.ver.ativo svg {
  fill: var(--cor-branco-fixo);
}
.opcoes button.ver:hover {
  background-color: var(--cor-escuro-4);
}
.opcoes button.ver:hover svg {
  fill: var(--cor-branco);
}
.opcoes button.ver svg {
  width: 15px;
  min-width: 15px;
  fill: var(--cor-escuro-6);
  transition: all 0.3s;
}
.opcoes .subir {
  position: relative;
}
.opcoes .subir button.abrir {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 8px;
  background-color: var(--cor-marca);
  transition: all 0.3s;
}
.opcoes .subir button.abrir:hover {
  background-color: var(--cor-marca-escuro);
}
.opcoes .subir button.abrir p {
  font-family: var(--medium);
  font-size: var(--f1);
  color: var(--cor-branco-fixo);
}
.opcoes .subir button.abrir svg {
  width: 15px;
  min-width: 15px;
  fill: var(--cor-branco-fixo);
  margin: 0 5px 0 0;
}
.opcoes .subir .subindo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 250px;
  min-width: 250px;
  padding: 15px;
  position: absolute;
  top: 60px;
  right: 0;
  background-color: var(--cor-escuro-1);
  border: 2px solid var(--cor-escuro-3);
  border-radius: 8px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translate(0, 20px);
  transition: all 0.3s;
}
.opcoes .subir .subindo .info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}
.opcoes .subir .subindo .free {
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
}
.opcoes .subir .subindo .free svg {
  width: 50px;
  min-width: 50px;
}
.opcoes .subir .subindo .free p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  line-height: 1.5;
  margin: 10px 0 10px 0;
}
.opcoes .subir .subindo.mostrar {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
  transform: translate(0, 0);
}
.opcoes .subir .subindo .link {
  display: flex;
  align-items: center;
  margin: 0 0 10px 0;
}
.opcoes .subir .subindo .link:hover svg {
  fill: var(--cor-branco);
}
.opcoes .subir .subindo .link:hover p {
  color: var(--cor-branco);
}
.opcoes .subir .subindo .link svg {
  width: 12px;
  min-width: 12px;
  fill: var(--cor-escuro-6);
  margin: 0 5px 0 0;
  transition: all 0.3s;
}
.opcoes .subir .subindo .link p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  transition: all 0.3s;
}
.opcoes .subir .subindo .usuario {
  display: flex;
  align-items: center;
}
.opcoes .subir .subindo .usuario .foto {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: var(--cor-escuro-4);
  background-size: cover;
  background-position: center;
  margin: 0 5px 0 0;
}
.opcoes .subir .subindo .usuario p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-branco);
}
/* Responsivo */
@media screen and (max-width: 1000px) {
  section.topo {
    height: 60px;
  }
  .nome {
    width: auto;
  }
  .nome .info {
    display: flex;
  }
  .nome .info h3 {
    display: none;
  }
  .nome .info span {
    display: none;
  }
  .nome .info a {
    display: none;
  }
  .nome .editar {
    display: none;
  }
  .nome .status {
    margin: 0;
  }
  .ajustes {
    padding: 0 0 0 15px;
    width: auto;
  }
  .ajustes a.voltar {
    height: 30px;
    width: 30px;
    min-width: 30px;
  }
  .ajustes button.opcao {
    height: 30px;
    margin: 0 0 0 10px;
  }
  .ajustes button.opcao svg {
    margin: 0;
  }
  .ajustes button.opcao p {
    display: none;
  }
  .opcoes {
    width: auto;
    padding: 0 15px 0 0;
  }
  .opcoes button.ver {
    height: 30px;
    width: 30px;
    margin: 0 10px 0 0;
  }
  .opcoes button.ver svg {
    width: 12px;
    min-width: 12px;
  }
  .opcoes .subir button.abrir {
    height: 30px;
    width: 30px;
    padding: 0;
  }
  .opcoes .subir button.abrir p {
    display: none;
  }
  .opcoes .subir button.abrir svg {
    width: 15px;
    min-width: 15px;
    margin: 0;
  }
  .download {
    display: none;
  }
}
</style>
